import { isDataURL } from 'assets/js/helpers/dataUrl';
import { sanitizeHoverOutlineSvg, sanitizeIgnoredSaveTagsSvg } from 'assets/js/helpers/fixPageSvg';

export default function sanitizeContent (content) {
  if (!(content && (typeof content === 'string' || content instanceof String))) {
    return content; // Not a string so return;
  }

  return content?.replace(/&nbsp;/g, ' ')
    .replace(/>[\t\n\s]+<(?!\/(?:tspan|text))/g, '><')
    .replace(/<\/a>[\t\n\s]+<(\/tspan)/g, '</a></tspan')
    .replace(/<\/tspan>\s*/g, '</tspan>')
    .replace(/\s*<tspan/g, '<tspan')
    .replace(/<\/text>\s*/g, '</text>')
    .replace(/\s*<text/g, '<text')
    .replace(/<\/g>\s*/g, '</g>')
    .replace(/<\/svg>\s*/g, '</svg>')
    .trim();
}

export function sanitizeSavingContent (content) {
  const toCleanDOM = svgedit.utilities.text2xml(content);

  sanitizeIgnoredSaveTagsSvg(toCleanDOM);
  sanitizeHoverOutlineSvg(toCleanDOM);
  cleanAnimationStyle(toCleanDOM);

  const imageSanitizedContent = processOriginalImageSizes(toCleanDOM);
  const spaceSanitizeContent = sanitizeContent(imageSanitizedContent);

  return spaceSanitizeContent;
}

function cleanAnimationStyle (toCleanDOM) {
  toCleanDOM.querySelectorAll('.element').forEach((el) => {
    svgedit.sanitize.sanitizeSvgStyle(el);
  });
}

function processOriginalImageSizes (toCleanDOM) {
  $(toCleanDOM).find('image').each(function (index, image) {
    const id = image.getAttribute('id');
    const $dirtyImage = $('#svgroot image#' + id);

    if (!$dirtyImage.length) {
      deferredError('Original image not found');
      return;
    }

    const dirtyImageDataUrl = INKIVE.ImagesFactory.getImageUrl($dirtyImage[0]);
    const isDataUrl = isDataURL(image.getAttribute('xlink:href'));

    if (dirtyImageDataUrl || !isDataUrl) {
      const loadCacheVersion = !$dirtyImage[0].getAttribute('xlink:href') || isDataUrl;

      loadCacheVersion && INKIVE.Image.Helpers.processDataUrlImage(image, dirtyImageDataUrl);
      loadCacheVersion || INKIVE.Image.Helpers.processXlinkImage(image, $dirtyImage[0]);
      INKIVE.Image.Helpers.processFlippedImage(image);
    } else {
      deferredError('Error: inlined image with no url version');
    }

    function deferredError (message) {
      image.remove();
      _.defer(function () { throw new ImageException(message); });
    }
  });

  const svgNode = $(toCleanDOM).find('svg')[0];
  svgNode.setAttribute('xmlns:xlink', svgedit.NS.XLINK);

  return INKIVE.EditorFacade.editor.getSvgString(svgNode);
}

function ImageException (message) {
  this.message = message;
  this.name = 'ImageException';
}
